// A readable site name from a domain when no title could be inferred, e.g.
// "behavioralscientist.org" -> "Behavioralscientist". Shared by the
// composer's client-side guess (classifyUrl) and the published-post
// normalizer (linkAttachmentFromMetadata) so a bare chip's label reads the
// same way regardless of which path produced it.
export const siteName = (domain: string): string => {
  const stripped = domain
    .replace(/\.(co|com|org|net|gov|ac)\.[a-z]{2,3}$/i, "")
    .replace(/\.[a-z]{2,24}$/i, "");
  const label = stripped.split(".").pop() || domain;
  return label.charAt(0).toUpperCase() + label.slice(1);
};
